import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGoogleAnalytics, onCookieConsentUpdated, trackPageView } from '../../utils/analytics';

const AnalyticsRouteTracker: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    onCookieConsentUpdated();
  }, []);

  useEffect(() => {
    const onConsent = () => onCookieConsentUpdated();
    window.addEventListener('cookie-consent-updated', onConsent);
    return () => window.removeEventListener('cookie-consent-updated', onConsent);
  }, []);

  useEffect(() => {
    initGoogleAnalytics();
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
};

export default AnalyticsRouteTracker;
